module.exports = __webpack_public_path__ + "static/media/pamain-bold.cf73c1e1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-bold.ttf
// module id = ./src/assets/fonts/pamain-bold.ttf
// module chunks = 6